import { forwardRef } from "react"
import { twMerge } from "tailwind-merge"

export type CardProps =
  | ({
      as?: React.ElementType
    } & React.HTMLAttributes<HTMLDivElement>)
  | ({
      as: "div"
    } & React.HTMLAttributes<HTMLDivElement>)
  | ({
      as: "form"
    } & React.FormHTMLAttributes<HTMLFormElement>)
  | ({
      as: "button"
    } & React.ButtonHTMLAttributes<HTMLButtonElement>)

/**
 * A container for grouping related information, styled as an elevated surface with a border.
 *
 * ```tsx
 * import { Card } from "@tokenterminal/core/ui/layout/card/Card"
 *
 * <Card>
 *   Hello there
 * </Card>
 * ```
 */

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { as: Component = "div", children, className, ...props },
  ref
) {
  return (
    <Component
      ref={ref}
      className={twMerge(
        "rounded-md p-8 border border-solid border-border-default bg-bg-surface",
        className
      )}
      {...props}
    >
      {children}
    </Component>
  )
})
